import { FiUpload } from 'react-icons/fi';
import { LuTrophy } from "react-icons/lu";
import { BsStars } from 'react-icons/bs';
import { RiCoinsLine } from 'react-icons/ri';

export default function FeatureRoadmap() {
  const features = [
    {
      icon: <FiUpload />,
      title: 'Video submissions',
      description: 'Creators can submit videos with an entry fee, competing for prediction pools',
      quarter: 'Coming Q1 2025',
      color: 'purple',
      glowColor: 'rgba(139, 92, 246, 0.5)'
    },
    {
      icon: <RiCoinsLine />,
      title: 'Creator payouts',
      description: 'Winners share revenue with creators based on engagement and prediction activity',
      quarter: 'Coming Q2 2025',
      color: 'cyan',
      glowColor: 'rgba(6, 182, 212, 0.5)'
    },
    {
      icon: <BsStars />,
      title: 'Generative AI video models',
      description: 'AI-generated video battles with unique prompts and community voting',
      quarter: 'Coming Q3 2025',
      color: 'yellow',
      glowColor: 'rgba(234, 179, 8, 0.5)'
    },
    {
      icon: <LuTrophy />,
      title: 'Tournaments',
      description: 'Compete in seasonal tournaments with mega prizes and leaderboard rewards',
      quarter: 'Coming Q4 2025',
      color: 'pink',
      glowColor: 'rgba(236, 72, 153, 0.5)'
    }
  ];

  return (
    <section id="roadmap" className="section feature-roadmap">
      <div className="container">
        <div className="section-header text-center">
          <h1>Future features</h1>
          <p>The roadmap to the ultimate video prediction platform</p>
        </div>

        <div className="roadmap-container">
          {/* Timeline Line Background */}
          <div className="timeline-line"></div>

          <div className="roadmap-grid">
            {features.map((feature, index) => (
              <div
                key={index}
                className={`glass-card roadmap-card theme-${feature.color}`}
                style={{ '--card-glow': feature.glowColor } as React.CSSProperties}
              >
                <div className="card-top">
                  <div className="icon-wrapper">
                    {feature.icon}
                  </div>
                </div>
                {/* Timeline Dot 
                <div className="timeline-dot-wrapper">
                  <div className="timeline-dot"></div>
                  <div className="timeline-connector"></div>
                </div>
                */}

                <div className="card-content">
                  <h4>{feature.title}</h4>
                  <p>{feature.description}</p>
                  <div className="badge-wrapper">
                    <span className="quarter-badge">{feature.quarter}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
